/**
 * Canonical company id for TanStack query keys that must not diverge on `"16"` vs `16`.
 *
 * @param {string | number | null | undefined} companyID
 * @returns {number | null}
 */
export function canonicalizeCompanyId(
  companyID: string | number | null | undefined
): number | null {
  if (companyID == null || companyID === '') {
    return null;
  }
  const n = typeof companyID === 'number' ? companyID : Number(String(companyID).trim());
  return Number.isFinite(n) ? n : null;
}
